import Text from 'particles/Text'
import React from 'react'
import BaseDivider from '../PredefinedTaskEditor/BaseDivider'

interface HeaderProps {
    title: string
    subtitle?: string
}

const Header: React.FC<HeaderProps> = ({ title, subtitle }) => {
    return (
        <>
            <div className="form-title">
                <Text scale="H4" color="primary">
                    {title}
                </Text>
                {subtitle ? (
                    <Text color="secondary" className="step-subtitle">
                        {subtitle}
                    </Text>
                ) : null}
            </div>
            <BaseDivider isFormTitleDivider />
        </>
    )
}

export default Header
